import Button from 'components/button';
import { EFavoritesType, ISelectItem } from 'lib/types';

import styles from './styles.module.scss';
import { Select } from 'components/select';
import useFavoriteList from 'api/hooks/use-favorite-list';
import { useEffect } from 'react';
import { FavouritesType } from 'lib/dictionary';
import useBoundStore from 'store';
import { MarketTypes } from 'api/types';
import useAddFacilityToFavoriteList from 'api/hooks/use-favorite-list-add-facility';
import { isoToKrasnoyarskTime } from 'lib/utils';

interface IAddFacilityToFavoriteListForm {
  onClose: () => void;
  marketType: MarketTypes;
  facilityIds: number[];
}

const AddFacilityToFavoriteListForm = ({
  onClose,
  marketType,
  facilityIds,
}: IAddFacilityToFavoriteListForm) => {
  const favoriteListIdSelected = useBoundStore((s) => s.favoriteListIdSelected)[`${marketType}`];
  const favoriteListTypeSelected = useBoundStore((s) => s.favoriteListTypeSelected)[
    `${marketType}`
  ];

  const setFavoriteListTypeSelected = useBoundStore((s) => s.setFavoriteListTypeSelected);
  const setFavoriteListIdSelected = useBoundStore((s) => s.setFavoriteListIdSelected);
  const payload = { types: [favoriteListTypeSelected], marketType };
  const { favoriteList, mutate } = useFavoriteList(payload);

  const {
    trigger,
    error: addError,
    isMutating: isMutating,
  } = useAddFacilityToFavoriteList(favoriteListIdSelected, facilityIds);

  const addFacilityToFavorite = async () => {
    if (favoriteListIdSelected && facilityIds) {
      await trigger();
      onClose();
    }
  };

  useEffect(() => {
    mutate();
  }, [favoriteListTypeSelected]);

  const transformedList: ISelectItem[] =
    favoriteList?.map((favorite) => ({
      key: favorite.id,
      label: favorite.title,
      note: `Cоздан: ${isoToKrasnoyarskTime(favorite.createdAt)} | кол-во: ${
        favorite.facilitiesCount
      }`,
    })) ?? [];

  return (
    <div className={styles.container}>
      <div className={styles.title}>{`Добавить элемент в список`}</div>

      <div className={styles.select}>
        <Select
          size='lg'
          label={'Укажите тип списока'}
          selected={favoriteListTypeSelected}
          multiple={false}
          onSelect={(value: EFavoritesType) => setFavoriteListTypeSelected(value, marketType)}
          menuArray={[
            { key: EFavoritesType.Personal, label: FavouritesType.label(EFavoritesType.Personal) },
            { key: EFavoritesType.Customer, label: FavouritesType.label(EFavoritesType.Customer) },
            { key: EFavoritesType.Shared, label: FavouritesType.label(EFavoritesType.Shared) },
          ]}
        />
      </div>

      <div className={styles.select}>
        <Select
          size='lg'
          label={'Укажите список'}
          search
          selected={favoriteListIdSelected}
          multiple={false}
          onSelect={(value: number) => setFavoriteListIdSelected(value, marketType)}
          menuArray={transformedList}
        />
      </div>

      <div className={styles.flexButton}>
        <Button variant='gray' onClick={onClose} label='Отменить' />
        <Button onClick={() => addFacilityToFavorite()} label='Добавить' loading={isMutating} />
      </div>
    </div>
  );
};

export default AddFacilityToFavoriteListForm;
